<!-- src/components/community/CommunityForm.vue -->
<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-btn color="primary" icon v-on="on" @click="openDialog">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
<span>Nueva Comunidad</span>
</v-tooltip>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card class="rounded-lg" outlined>
        <v-card-title >

          <v-icon left color="primary">mdi-account-group-outline</v-icon>
          Nueva Comunidad
        </v-card-title>
        <v-divider />

        <v-card-text class="pa-4 px-8">
          <v-form ref="form" @submit.prevent="createCommunity">
            <v-text-field v-model="community.name" label="Nombre de la Comunidad"
              :rules="[v => !!v || 'El nombre es requerido']" outlined ></v-text-field>

            <v-switch
              v-model="community.isPublic"
              label="Comunidad Pública (disponible para todos los usuarios)"
              class="mb-3"
              hint="Las comunidades públicas están disponibles para todos los usuarios, incluso los nuevos"
              persistent-hint
            ></v-switch>

            <template v-if="!community.isPublic">
              <v-autocomplete v-model="community.members" :items="availableUsers" item-text="displayName" item-value="id"
                label="Seleccionar Miembros" multiple chips small-chips outlined deletable-chips hide-details=""
                :rules="[v => community.isPublic || v.length > 0 || 'Debe seleccionar al menos un usuario']"
                :disabled="community.isPublic"
                :loading="loadingUsers"></v-autocomplete>

            <v-checkbox
                v-model="selectAll"
                label="Seleccionar todos los miembros"
                @change="toggleSelectAll"
                :disabled="community.isPublic"
              ></v-checkbox>
            </template>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog" class="mr-2">
            Cancelar
          </v-btn>
          <v-btn color="success" @click="createCommunity" :loading="loading" class="px-4">
            
            Crear
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { collection, addDoc, getFirestore, doc, updateDoc, getDocs, query, where } from "firebase/firestore";
import { arrayUnion } from "firebase/firestore";

export default {
  name: "CommunityForm",
  data() {
    return {
      dialog: false,
      loading: false,
      loadingUsers: false,
      availableUsers: [],
      community: {
        name: "",
        members: [],
        isPublic: true,
      },
      selectAll: false,
    };
  },
  methods: {
    async openDialog() {
      this.dialog = true;
      this.loadingUsers = true;
      await this.fetchAvailableUsers();
      this.loadingUsers = false;
    },
    
    async fetchAvailableUsers() {
      const db = getFirestore();
      const q = query(collection(db, "users"), where("disabled", "==", false));
      const querySnapshot = await getDocs(q);
      let users = querySnapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .sort((a, b) => {
          if (a.displayName.toLowerCase() < b.displayName.toLowerCase()) {
            return -1;
          }
          if (a.displayName.toLowerCase() > b.displayName.toLowerCase()) {
            return 1;
          }
          return 0;
        });

      this.availableUsers = users;
    },
    
    async createCommunity() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          const db = getFirestore();

          // Create new community
          const docRef = await addDoc(collection(db, "communities"), {
            name: this.community.name,
            members: this.community.isPublic ? [] : this.community.members,
            isPublic: this.community.isPublic
          });

          // Update users' enabledCommunities if not public
          if (!this.community.isPublic) {
            for (const userId of this.community.members) {
              const userRef = doc(db, "users", userId);
              await updateDoc(userRef, {
                enabledCommunities: arrayUnion(docRef.id),
              });
            }
          }

          // Emit the new community
          this.$emit("create", {
            id: docRef.id,
            ...this.community,
          });

          this.$notify({
            title: "Comunidad creada",
            text: "La comunidad ha sido creada exitosamente",
            type: "success",
          });

          this.closeDialog();
        } catch (error) {
          console.error("Error creating community:", error);
          this.$notify({
            title: "Error",
            text: "Ocurrió un error al crear la comunidad",
            type: "error",
          });
        }
        this.loading = false;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.$refs.form.reset();
      this.community = {
        name: "",
        members: [],
        isPublic: true,
      };
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.community.members = this.availableUsers.map(user => user.id);
      } else {
        this.community.members = [];
      }
    },
  },
  watch: {
    'community.members': {
      handler(newValue) {
        // Update selectAll based on whether all users are selected
        this.selectAll = newValue.length === this.availableUsers.length;
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.v-card {
  transition: transform 0.2s;
}

</style>
